import React from 'react'
import { Stack } from '@mui/material'
import { SegmentStack, AppearancesStack } from './stacks'
import { SPACING, HeaderBody } from '../../typography'
import SpacedPaper from '../../typography/spaced-paper'
import OverflowWrapper from '../../overflow-wrapper'

export function SegmentItem(props) {
  const { appearances = [], desc = '', children = null } = props
  return (
    <>
      <Stack spacing={SPACING} sx={{ minWidth: 350, maxWidth: 400 }}>
        {desc && (
          <SpacedPaper>
            <OverflowWrapper maxHeight={100}>
              <HeaderBody>{desc}</HeaderBody>
            </OverflowWrapper>
          </SpacedPaper>
        )}
        {appearances?.length > 0 && <AppearancesStack {...props} />}
        <SegmentStack {...props} />
      </Stack>
      {children}
    </>
  )
}
